{
  "loanWidget": {
    "preliminaryLoanAmountHeading": "Katso yrityksesi luottoraja",
    "privacyPolicyConsent": "Sinun tulee hyväksyä, että {{company}} käsittelee <1>henkilötietojasi</1> lainamahdollisuuksien tarkistamiseksi",
    "estimateLimitWithoutCreditCheck": "Tarkista luottorajasi",
    "estimateLimit": "Tarkista luottorajasi",
    "loadingText": "Arvioidaan kuinka paljon voit saada lainaa...",
    "makeAnotherEstimate": "Tee toinen arvio",
    "yourEstimatedCreditLimit": "Arvioitu luottorajasi",
    "immediateResponse": "Näet vastauksen heti",
    "immediateResponseWithoutCreditCheck": "Näet vastauksen heti",
    "trustTagFreeOfCharge": "Ilmainen",
    "trustTagOffersWithin24h": "Tarjoukset 24 tunnin sisällä",
    "trustTagLenders": "15+ rahoittajaa",
    "whatHappensNextTitle": "Mitä tapahtuu seuraavaksi?",
    "whatHappensNextStep1": "Täytä hakemus — vie vain muutaman minuutin",
    "whatHappensNextStep2": "Saat tarjouksia rahoittajilta 24 tunnin sisällä",
    "whatHappensNextStep3": "Vertaa ja valitse paras tarjous",
    "trustTagsListLabel": "Ennen kuin lähetät",
    "veryHighLikelihood": "Erittäin korkea todennäköisyys saada tarjouksia",
    "highLikelihood": "Korkea todennäköisyys saada tarjouksia",
    "possibleLikelihood": "Tarjousten saaminen on mahdollista",
    "estimatedRange": "Arvioitu luottoraja",
    "advisoryResultTitle": "Emme voineet arvioida luottorajaasi automaattisesti",
    "advisoryResultDescription": "Automaattinen arviomme on käytettävissä vain summille, jotka ovat korkeintaan {{amount}}. Suuremmille summille rahoitusneuvojamme antaa henkilökohtaista palvelua.",
    "advisoryMeetingPrompt": "Varaa rahoitusneuvonta mahdollisuuksien kartoittamiseksi!",
    "whatIsAdvisoryService": "Mikä on neuvontapalvelu?",
    "advisoryServiceDescription1": "Tarjoamme erikoistunutta neuvontapalvelua, joka auttaa pieniä ja keskisuuria yrityksiä saamaan optimaalista rahoitusta alhaisemmalla korolla. Palvelu on erityisen hyödyllinen yrityksille, jotka hakevat rahoitusta {{amountLow}} ja {{amountHigh}} välillä.",
    "advisoryServiceDescription2": "Neuvonantajamme auttavat sinua rahoitusesityksen luomisessa, mikä antaa lainantarjoajille selkeän kuvan yrityksesi vahvuuksista.",
    "advisoryServiceDescription3": "Sinulla on yhteys henkilökohtaiseen neuvonantajaasi koko prosessin ajan. Varaa halutessasi aika tapaamiselle.",
    "continueNowToGetRealOffers": "Jatka nyt ja saa rahoitustarjouksia!",
    "howItWorksDescription1": "Vain yksi hakemus",
    "howItWorksDescription2": "<strong>Parhaat ehdot:</strong> Kilpailutamme 15+ rahoittajaa",
    "howItWorksDescription3": "<strong>Säästä aikaa:</strong> Saa tarjouksia 24 tunnin sisällä",
    "largerAmountsPossible": "Suuremmat summat ovat mahdollisia leasingilla, laskurahoituksella tai kiinteistölainalla",
    "howCanYouImproveYourChances": "Miten voit parantaa mahdollisuuksiasi saada koko haettu summa?",
    "improveYourChancesTitle": "Näin maksimoit lainasi",
    "improveYourChancesIntro": "Voit normaalisti lainata 10–20% yrityksesi liikevaihdosta. Onko liikevaihtosi kasvanut äskettäin? Muista korostaa tätä hakemuksessasi – se voi tehdä suuren eron.",
    "improveYourChancesLargerAmounts": "Suuremmat lainasummat voivat olla mahdollisia joissakin tapauksissa:",
    "improveYourChancesBullet1Question": "Oletko hankkimassa kalustoa?",
    "improveYourChancesBullet1Text": "Käytä sitä vakuutena tai rahoita leasing-sopimuksella ja luo mahdollisuus suuremmalle summalle.",
    "improveYourChancesBullet2Question": "Voitko tarjota lisävakuuksia?",
    "improveYourChancesBullet2Text": "Kiinteistövakuus tai yrityskiinnitys voi antaa sinulle jopa 60–80% niiden arvosta.",
    "improveYourChancesBullet3Question": "Kuulutko konserniin?",
    "improveYourChancesBullet3Text": "Lainavaihtoehtojen tutkiminen emoyhtiön kautta voi avata uusia mahdollisuuksia.",
    "improveYourChancesReasonableAmount": "Muista myös hakea kohtuullista summaa – liian suuret summat voivat johtaa hylkäämiseen.",
    "improveYourChancesContactUs": "Autamme sinua löytämään oikean ratkaisun. Aloita hakemus tai <contactLink>ota yhteyttä</contactLink> suoraan, niin löydämme oikean ratkaisun yhdessä.",
    "howWeEstimatedDescription1": "Arvio perustuu aiempiin tarjouksiin, joita samankaltaiset yritykset ovat saaneet. Keräämme julkisia tietoja yrityksestäsi arvioidaksemme luottorajasi.",
    "howWeEstimatedDescription2": "Saatat todellisuudessa saada korkeamman tai matalamman tarjouksen.",
    "howWeEstimatedDescription3": "Ainoa tapa selvittää, mitä yrityksesi voi oikeasti saada, on tehdä hakemus.",
    "bookAMeeting": "Varaa ilmainen tapaaminen",
    "continueToApplication": "Jatka hakemukseen",
    "expandCalculatorForm": "Näytä lisää",
    "collapseCalculatorForm": "Näytä vähemmän"
  },
  "foretagarnaContent": {
    "title": "",
    "resultMemberBenefitText": ""
  },
  "applicationForm": {
    "commons": {
      "requestedAmountPreLabel": "Lainasumma",
      "exactRequestedAmountPlaceholder": "100 000 {{currency}}",
      "emailErrors": {
        "validationError": "Kirjoita voimassa oleva sähköpostiosoite"
      }
    }
  }
}
